const outcomes = [
  { icon: 'ri-graduation-cap-line', title: 'Education Success', desc: 'Academic support, school re-engagement, and clear pathways to graduation.' },
  { icon: 'ri-briefcase-line', title: 'Youth Employment', desc: 'Resume building, interview skills, and workplace confidence for real-world readiness.' },
  { icon: 'ri-home-smile-line', title: 'Independent Living', desc: 'Cooking, cleaning, budgeting, and self-care skills for a confident transition to adulthood.' },
  { icon: 'ri-hand-heart-line', title: 'Healthy Relationships', desc: 'Forming positive, supportive connections with peers, mentors, and community.' },
  { icon: 'ri-bank-line', title: 'Financial Literacy', desc: 'Money management, saving habits, and informed financial decision-making.' },
  { icon: 'ri-global-line', title: 'Cultural Identity', desc: 'Reconnecting with heritage, traditions, and community that affirm who they are.' },
  { icon: 'ri-team-line', title: 'Community Integration', desc: 'Building belonging through volunteering, recreation, and local engagement.' },
  { icon: 'ri-sun-line', title: 'Confidence Building', desc: 'Discovering personal strengths and building genuine belief in their own potential.' },
  { icon: 'ri-compass-3-line', title: 'Goal Achievement', desc: 'Setting meaningful goals and developing the skills to reach them step by step.' },
  { icon: 'ri-tools-line', title: 'Life Skills', desc: 'Practical everyday skills that build independence, responsibility, and self-reliance.' },
];

export default function OutcomesSection() {
  return (
    <section id="outcomes" className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
            Outcomes That Matter
          </span>
          <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 max-w-3xl mx-auto leading-tight">
            We measure success by <span className="italic text-primary-600">who</span> the young person becomes.
          </h2>
          <p className="text-foreground-600 mt-5 max-w-2xl mx-auto leading-relaxed text-base md:text-lg">
            Every interaction is intentional. Every milestone matters. Every youth receives individualized support designed around their strengths, goals, and potential.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {outcomes.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:bg-primary-50/30 cursor-default flex flex-col"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-700 rounded-xl mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-semibold text-foreground-900 mb-2 label-font text-sm">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed flex-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}